import { render, staticRenderFns } from "./FireMarshalContact.vue?vue&type=template&id=27a9695c&scoped=true&"
import script from "./FireMarshalContact.vue?vue&type=script&lang=js&"
export * from "./FireMarshalContact.vue?vue&type=script&lang=js&"
import style0 from "./FireMarshalContact.vue?vue&type=style&index=0&id=27a9695c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a9695c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27a9695c')) {
      api.createRecord('27a9695c', component.options)
    } else {
      api.reload('27a9695c', component.options)
    }
    module.hot.accept("./FireMarshalContact.vue?vue&type=template&id=27a9695c&scoped=true&", function () {
      api.rerender('27a9695c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/edit/FireMarshalContact.vue"
export default component.exports